import React from "react";

const DashProfileIcon = ({ width, height, color }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.5"
        d="M12.7936 11C10.5916 11 8.80664 9.20914 8.80664 7C8.80664 4.79086 10.5916 3 12.7936 3C14.9955 3 16.7805 4.79086 16.7805 7C16.7805 9.20914 14.9955 11 12.7936 11Z"
        fill={color || "#828282"}
      />
      <path
        d="M3.82389 20.1992C4.21023 15.4265 8.07123 13 12.7772 13C17.5495 13 21.4703 15.2932 21.7623 20.2C21.774 20.3955 21.7623 21 21.0136 21C17.3201 21 11.8317 21 4.54837 21C4.2984 21 3.80285 20.4592 3.82389 20.1992Z"
        fill={color || "#828282"}
      />
    </svg>
  );
};

export default DashProfileIcon;
